import React from "react";
import { useTranslation } from "react-i18next";
import { CONFLICT_ROW_STYLE, ESTADO_PV_BADGE_STYLE } from "./seleccionBobinasUtils";

/**
 * Static legend explaining the simplified color scheme used by this IDAX
 * replica. The original AX CMT_INF form used up to 13 distinct
 * custReservationType colors; this replica only distinguishes 4 candidate
 * states (see CmtSeleccionBobinasConflictCode on the backend) plus the 4
 * SalesTable workflow states, and documents that simplification explicitly.
 */
export default function LegendTab() {
  const { t } = useTranslation();

  const conflictRows = [
    { code: "NONE", labelKey: "seleccionBobinas.legend.conflictNone" },
    { code: "SELECTED_HERE", labelKey: "seleccionBobinas.legend.conflictSelectedHere" },
    { code: "SELECTED_ELSEWHERE_FULL", labelKey: "seleccionBobinas.legend.conflictSelectedElsewhereFull" },
    { code: "SELECTED_ELSEWHERE_PARTIAL", labelKey: "seleccionBobinas.legend.conflictSelectedElsewherePartial" },
  ];

  const estadoRows = [
    { code: 0, labelKey: "axEnums.CMTSeleccionBobinasEstadoPV.0" },
    { code: 1, labelKey: "axEnums.CMTSeleccionBobinasEstadoPV.1" },
    { code: 2, labelKey: "axEnums.CMTSeleccionBobinasEstadoPV.2" },
    { code: 3, labelKey: "axEnums.CMTSeleccionBobinasEstadoPV.3" },
  ];

  return (
    <div>
      <p style={{ fontStyle: "italic", color: "#6b7280" }}>{t("seleccionBobinas.legend.disclaimer")}</p>

      <h4>{t("seleccionBobinas.legend.candidateColorsTitle")}</h4>
      <table className="table table-bordered" style={{ maxWidth: 640 }}>
        <thead>
          <tr>
            <th>{t("seleccionBobinas.legend.columnColor")}</th>
            <th>{t("seleccionBobinas.legend.columnMeaning")}</th>
          </tr>
        </thead>
        <tbody>
          {conflictRows.map((row) => (
            <tr key={row.code}>
              <td>
                <span style={{
                  display: "inline-block",
                  width: 28,
                  height: 18,
                  border: "1px solid #d1d5db",
                  ...CONFLICT_ROW_STYLE[row.code],
                }} />
              </td>
              <td>{t(row.labelKey)}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <h4 style={{ marginTop: 24 }}>{t("seleccionBobinas.legend.statusColorsTitle")}</h4>
      <table className="table table-bordered" style={{ maxWidth: 640 }}>
        <thead>
          <tr>
            <th>{t("seleccionBobinas.legend.columnColor")}</th>
            <th>{t("seleccionBobinas.legend.columnMeaning")}</th>
          </tr>
        </thead>
        <tbody>
          {estadoRows.map((row) => (
            <tr key={row.code}>
              <td>
                <span style={{
                  display: "inline-block",
                  padding: "2px 10px",
                  borderRadius: 12,
                  fontSize: 12,
                  fontWeight: 600,
                  ...ESTADO_PV_BADGE_STYLE[row.code],
                }}>
                  {t(row.labelKey)}
                </span>
              </td>
              <td>{t(row.labelKey)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
